export default "__VITE_ASSET__BN7iEx7D__"